import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button.jsx';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import { put } from 'helpers/apiHelpers';
import { isGranted } from 'helpers/helpers';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import roles from 'helpers/roles';
import GridItem from 'components/Grid/GridItem';
import produce from 'immer';
import makeStyles from '@material-ui/styles/makeStyles';
import { toast } from 'react-toastify';
import { mailingOptions } from 'views/MailNotifications/constans';

const useStyles = makeStyles({
  ...extendedFormsStyle,
  ...buttonsStyle,
});

const MailNotificationClientToggleableCard = ({
  clientMailing,
  mailing,
  adminMailing,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [state, setState] = useState({ mailing });

  return (
    <Card>
      <CardBody>
        <GridItem md={12}>
          <h3>{t('mailNotifications.cardTitle.clientAllowToToggle')}</h3>
        </GridItem>
        <div style={{ overflow: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('notify.whatMail')}</TableCell>
                <TableCell>{t('notify.allowClientToToggle')}</TableCell>
                {isGranted(roles.ROLE_EDIT_MAIL_CONFIGURATION) && (
                  <TableCell>{t('notify.actions')}</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.mailing.map(mailingOption => {
                const mailingOptionTranslation =
                  mailingOptions(t)[mailingOption?.mailKey];

                if (!mailingOptionTranslation) {
                  return null;
                }

                // eslint-disable-next-line no-unsafe-optional-chaining -- FIXME
                const [clientEmailStatus] = clientMailing?.filter(
                  el => mailingOption['@id'] === el['@id']
                );

                // eslint-disable-next-line no-unsafe-optional-chaining -- FIXME
                const [adminEmailStatus] = adminMailing?.filter(
                  el => mailingOption['@id'] === el['@id']
                );

                const mainEmailStatus = clientEmailStatus || adminEmailStatus;
                return (
                  // eslint-disable-next-line react/jsx-key -- FIXME
                  <TableRow>
                    <TableCell>{mailingOptionTranslation}</TableCell>
                    <TableCell>
                      <Checkbox
                        checked={
                          mainEmailStatus?.enabledForClient
                            ? mailingOption?.allowClientToToggle
                            : false
                        }
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                        onChange={e => {
                          if (mainEmailStatus?.hasChanged) {
                            toast.warning(
                              t(
                                'mailNotification.userSettings.secondEmail.blocked'
                              )
                            );

                            return;
                          }

                          if (!mainEmailStatus?.enabledForClient) {
                            toast.error(
                              t(
                                'mailNotification.userSettings.mainEmail.blocked'
                              )
                            );
                            return;
                          }

                          const updatedMailing = produce(
                            state?.mailing,
                            draftMailing => {
                              const optionToChange = draftMailing?.find(
                                newMailingOption =>
                                  newMailingOption?.id === mailingOption?.id
                              );

                              optionToChange.allowClientToToggle =
                                !mailingOption?.allowClientToToggle;
                              optionToChange.hasChanged = true;
                            }
                          );

                          setState({
                            mailing: updatedMailing,
                          });
                        }}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                      />
                    </TableCell>
                    {isGranted(roles.ROLE_EDIT_MAIL_CONFIGURATION) && (
                      <TableCell>
                        <RegularButton
                          disabled={
                            // eslint-disable-next-line no-negated-condition -- FIXME
                            !mainEmailStatus?.enabledForClient
                              ? true
                              : !mailingOption?.hasChanged
                          }
                          color="success"
                          onClick={() => {
                            if (mainEmailStatus?.hasChanged) {
                              toast.warning(
                                t(
                                  'mailNotification.userSettings.secondEmail.blocked'
                                )
                              );

                              return;
                            }
                            put(mailingOption['@id'], {
                              allowClientToToggle:
                                mailingOption?.allowClientToToggle,
                              // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
                            }).then(
                              () => {
                                const updatedMailing = produce(
                                  state?.mailing,
                                  draftMailing => {
                                    const optionToChange = draftMailing?.find(
                                      newMailingOption =>
                                        newMailingOption?.id ===
                                        mailingOption?.id
                                    );

                                    optionToChange.hasChanged = false;
                                  }
                                );

                                setState({
                                  mailing: updatedMailing,
                                });

                                toast.success(t('notify.changesSaved'));

                                window.location.reload();
                              },
                              () => toast.error(t('notify.cannotSave'))
                            );
                          }}
                        >
                          {t('common.shared.save')}
                        </RegularButton>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default MailNotificationClientToggleableCard;
